import { useEffect } from 'react';

import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { loadScript } from 'lib/script';

declare global {
  interface Window {
    ApplePaySession?: any;
  }
}

const SDK_URL = 'https://applepay.cdn-apple.com/jsapi/v1.3.2/apple-pay-sdk.js';

const SDK_HASH =
  'sha384-DZRWMZLyVXr+7shJfal8pIG2v4KisLoSWFjZQMUv0+GWaCwoa82qeHsWrbBIUDPU';

export const useCanUseApplePay = () => {
  const {
    flags: { useLatestApplepaySdk },
  } = useFeatureFlags();

  useEffect(() => {
    if (!useLatestApplepaySdk) return;
    loadScript(SDK_URL, {
      integrity: SDK_HASH,
      crossOrigin: 'anonymous',
    });
  }, [useLatestApplepaySdk]);

  return (
    // eslint-disable-next-line no-restricted-properties
    window.location.protocol === 'https:' &&
    !!window.ApplePaySession &&
    ApplePaySession.canMakePayments()
  );
};
